import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    CircularProgress,
    List,
    ListItem,
} from '@material-ui/core'
import { ModelCard } from '../Organisms'
import { Analytics } from '../../utils'
import { useParams } from '../../utils/Hooks'

const ModelList = ({ handleClickCard, searchResult }) => {
    const { i18n } = useTranslation()
    const { page, page_size, subsection } = useParams()

    if (!searchResult) return <CircularProgress />
    return <List style={{ width: `100%`, padding: 0 }}>
        {searchResult.models.map((model, index) => (
            <ListItem key={model[`title_${i18n.language}`]} disableGutters>
                <ModelCard
                    model={model}
                    handleClickCard={() => {
                        if (subsection === 'models') {
                            Analytics.searchResultClick('model', index + 1 + (page - 1) * page_size)
                        } else {
                            Analytics.searchResultClick('model preview', 1)
                        }
                        Analytics.modelClickEvent(model[`title_${i18n.language}`])
                        handleClickCard(model)
                    }}
                />
            </ListItem>
        ))}
    </List>
}

export default ModelList